// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { readFileSync } from 'fs';

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCkimKVeEHQi3PilLUkJ8jl6XzTaZr_5FE',
    authDomain: 'refcoach-676e3.firebaseapp.com',
    databaseURL: 'https://refcoach-676e3.firebaseio.com',
    projectId: 'refcoach-676e3',
    storageBucket: 'refcoach-676e3.appspot.com',
    messagingSenderId: '252857255317'
  },
  version: '2.26.0-2026-07-20T09:35:24.791Z'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
